import { ConfigurationService } from '../../shared/services/configuration.service';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../core/user.service';
import { FeatureEnum } from '../../shared/models/feature-enum';
import { CustomerService } from '../shared/services/customer.service';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { CustomMessageService } from '@admin/core/message.service';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { CustomerStatusEnum } from '../shared/models/customer-status.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-customer-basic',
  templateUrl: './customer-basic.component.html',
  styleUrls: ['./customer-basic.component.less'],
  standalone: false,
})
export class CustomerBasicComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  @Output()
  public onUpdate: EventEmitter<boolean>;

  public dateFormat: string;
  public specialDateFormat: string;

  public hasCustomerArchivePermission: boolean;
  public CustomerStatusEnum: any;

  constructor(
    private config: ConfigurationService,
    private userService: UserService,
    private customerService: CustomerService,
    private translateService: TranslateService,
    private messageService: CustomMessageService
  ) {
    this.onUpdate = new EventEmitter<boolean>();
    this.hasCustomerArchivePermission = false;
    this.CustomerStatusEnum = CustomerStatusEnum;
  }

  onCustomerArchive() {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.customerService
        .archiveCustomer(this.customer.customerId)
        .subscribe((r) => {
          if (r.success) {
            this.showMessage(r.message, MessageType.Success);
            this.onUpdate.emit(true);
          } else {
            this.showMessage(r.message, MessageType.Error);
          }
        });
    }
  }

  getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.hasCustomerArchivePermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ArchiveCustomer
      );
  }

  private showMessage(message: string, type: MessageType) {
    if (message != null && message.length > 0) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: type,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: message,
      });
    }
  }
}
